import { newToolFilterOAuthMcp } from "../oauth.ts";

export const fellowMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://cdn.fellow.app/static/images/favicon/favicon.svg",
  url: "https://fellow.app/mcp",
  label: "Fellow",
});
